export default {
  partners: [],
  pagination: {},
  partner: {}
}
